import Result from "@/core/common/Result";
import {
  CSATMinhasEmpresasInput,
  ISalvarCSATMinhasEmpresasUseCase
} from "../ports/SalvarCSATMinhasEmpresasUseCase";
import { CSATHandlerFactory } from "../CSATGatewayHandlerFactory";
import { CSATGatewayHandlers } from "../ports/CSATHandler";
import { injectable } from "inversify";
import "reflect-metadata";
@injectable()
export class SalvarCSATMinhasEmpresasUseCaseAdapter
  implements ISalvarCSATMinhasEmpresasUseCase
{
  async execute(params: CSATMinhasEmpresasInput): Promise<Result<void>> {
    const handler = await CSATHandlerFactory.handler().handle(
      CSATGatewayHandlers.minhasEmpresas
    );

    if (!handler) return Result.fail("Ocorreu um erro inesperado");

    const response = await handler.salvar({
      nota: params.nota,
      comentario: params.comentario,
      pesquisaCSATId: params.id
    });

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
